import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "-1.5 -1.5 23 23",
	fill: "none",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#b)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				stroke: "currentColor",
				strokeWidth: .75,
				d: "M10.001 11.882a.87.87 0 0 1 .616.257l.001.002 2.242 2.242a.88.88 0 0 1 0 1.235l-2.243 2.243a.87.87 0 0 1-1.233 0L7.14 15.618a.883.883 0 0 1 0-1.235l2.242-2.242v-.002a.87.87 0 0 1 .618-.257Zm-5-5a.87.87 0 0 1 .616.257l.001.002L7.86 9.383a.883.883 0 0 1 0 1.235l-2.243 2.243a.87.87 0 0 1-1.233 0L2.14 10.618a.883.883 0 0 1 0-1.235L4.383 7.14v-.002a.87.87 0 0 1 .618-.257Zm10 0a.87.87 0 0 1 .616.257l.001.002 2.242 2.242a.88.88 0 0 1 0 1.235l-2.243 2.243a.87.87 0 0 1-1.233 0l-2.243-2.243a.883.883 0 0 1 0-1.235l2.242-2.242v-.002a.87.87 0 0 1 .618-.257Zm-5-5a.87.87 0 0 1 .616.257l.001.002 2.242 2.242a.88.88 0 0 1 0 1.235l-2.243 2.243a.87.87 0 0 1-1.233 0L7.14 5.618a.883.883 0 0 1 0-1.235L9.383 2.14v-.002a.87.87 0 0 1 .618-.257Z"
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M-1.5-1.5H21.5V21.5H-1.5z"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "b",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M-1.5-1.5H21.5V21.5H-1.5z"
		})
	})] })]
});
export default SvgAssetsActive;
